import { useEffect,useState } from "react";

const useFetchData=(url)=>{
    const [data,setData]=useState({})
    const [error,setError]=useState(null)
    const [loading,setLoading]=useState(false)
    const [message,setMessage]=useState(null)
    
    useEffect(()=>{
        const fetchData=async()=>{
            console.log("fetching data");
            setLoading(true)
            try{
                const res=await fetch(url, {
                    method: 'GET'
                })
                const result=await res.json();
                if(!result.success)
                {
                    throw new Error(result.message)
                }
                // console.log(result.data)
                setData(result.data)
                setMessage(result.message)
                setLoading(false)
            }catch(error)   {
                setLoading(false)
                setError(error.message)
            }
        }                
        fetchData()
    },[url])
    return {data,error,loading, message}

}
export default useFetchData;